import { render, staticRenderFns } from "./ShoppingCardSecond.vue?vue&type=template&id=12bf7656&scoped=true&"
import script from "./ShoppingCardSecond.vue?vue&type=script&lang=js&"
export * from "./ShoppingCardSecond.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCardSecond.vue?vue&type=style&index=0&id=12bf7656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf7656",
  null
  
)

export default component.exports